<template>
  <component
    v-bind="$props"
    :is="iconComponent"
    class="inline-block"
    :class="{ 'path-fill-current': !maintainColor }"
    @click="$emit('click', $event)"
  />
</template>

<script>
// see approach #2: https://jessarcher.com/blog/creating-an-icon-component-in-vue/
const icons = {}
const requireComponents = require.context(
  '../../../assets/icons/',
  false,
  /.svg$/,
)

requireComponents.keys().forEach((fileName) => {
  const iconName = fileName.replace(/^\.\/(.+)\.svg$/, '$1')
  const componentConfig = requireComponents(fileName)
  icons[iconName] = componentConfig.default || componentConfig
})

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      default: null,
    },
    maintainColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconComponent() {
      return icons[this.name]
    },
  },
}
</script>

<style lang="scss">
.path-fill-current path {
  @apply fill-current;
}
</style>
